<template>
  <v-btn
    color="#6A6E7B"
    outlined
    :loading="loading"
    @click="makeDownload()"
  >
    Baixar
  </v-btn>
</template>

<script>
import UploadService from '@/app/arch/services/UploadService';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';

export default {
  name: 'ReceiptDownloadColumn',
  mixins: [ServiceMixin],
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    requestClass: UploadService,
    loading: false,
  }),
  computed: {
    config() {
      return {
        errorMessage: `Falha ao buscar arquivo ${this.value} para download`,
        showSuccessSwal: false,
      };
    },
  },
  methods: {
    makeDownload() {
      this.handleLoading();
      this.makeRequestFile();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequestFile() {
      this.callService(
        this.requestClass.get(
          this.value,
        ),
        this.prepareResponse,
        this.config,
      );
    },
    prepareResponse(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.createFile(response.data);
      }
    },
    createFile(data) {
      const blob = new Blob([data], { type: 'image/jpeg;charset=utf-8' });

      this.exportFile(blob);
    },
    exportFile(file) {
      const link = document.createElement('a');
      link.download = this.value;
      link.href = URL.createObjectURL(file, { type: 'image/jpeg' });
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
};
</script>
